import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink href="https://goo.gl/maps/XPKPnbe3o1UEX1Rg9">
              <CFImage
                src={mobileMap}
                w="100%"
                alt="Sushico Japanese Cuisine"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink href="https://goo.gl/maps/XPKPnbe3o1UEX1Rg9">
              <CFImage
                src={locationMap}
                w="100%"
                alt="Sushico Japanese Cuisine"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
